import {
  BiLogoFacebook,
  BiLogoInstagramAlt,
  BiLogoSnapchat,
} from "react-icons/bi";
import { FaTiktok, FaYoutube } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

// Icon components for rendering
export const SocialMediaIcons = {
  1: BiLogoFacebook,
  2: BiLogoInstagramAlt,
  3: BsTwitterX,
  4: FaTiktok,
  5: FaYoutube,
  6: BiLogoSnapchat,
};

// Names for each platform
export const socialMediaNames = {
  1: "Facebook",
  2: "Instagram",
  3: "Twitter / X",
  4: "TikTok",
  5: "YouTube",
  6: "Snapchat",
};

export const socialMediaTypes = [
  { id: 1, label: <BiLogoFacebook className="social-media-icon" />, name: "Facebook", icon: BiLogoFacebook },
  { id: 2, label: <BiLogoInstagramAlt className="social-media-icon" />, name: "Instagram", icon: BiLogoInstagramAlt },
  { id: 3, label: <BsTwitterX className="social-media-icon" />, name: "Twitter / X", icon: BsTwitterX },
  { id: 4, label: <FaTiktok className="social-media-icon" />, name: "TikTok", icon: FaTiktok },
  { id: 5, label: <FaYoutube className="social-media-icon" />, name: "YouTube", icon: FaYoutube },
  { id: 6, label: <BiLogoSnapchat className="social-media-icon" />, name: "Snapchat", icon: BiLogoSnapchat },
];
